export default __webpack_public_path__ + "static/CreateCluster-be4c8cbbe8dcd04a1db25236ea76ad44.png";